import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=3a710616&"
import script from "./CustomerLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports